import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
const BOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/4bvjKmWZd3NtvDruvwvV8w/Portada_para_el_E-book_Por_que_Levantar_tu_autoestima_en_Epocas_de_Crisis.-.png';
export function OfferCTA() {
  return <section id="comprar" className="w-full bg-warm-dark-alt py-20 md:py-28 relative overflow-hidden" data-id="element-98">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-amber/[0.04] rounded-full blur-[120px] pointer-events-none" data-id="element-99" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-gradient-to-br from-warm-dark via-warm-dark to-warm-dark-alt border border-amber/20 rounded-3xl p-8 sm:p-12 md:p-16" data-id="element-101">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-102">
            {/* Book image */}
            <div className="flex justify-center" data-id="element-103">
              <motion.div animate={{
              y: [0, -8, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-104">
                <div className="absolute -inset-6 bg-amber/10 rounded-2xl blur-2xl pointer-events-none" data-id="element-105" />
                <img src={BOOK_COVER_URL} alt="eBook: La Importancia de Levantar tu Autoestima en Épocas de Crisis" className="relative w-[220px] sm:w-[260px] rounded-lg shadow-book" data-id="element-106" />
              </motion.div>
            </div>

            {/* Offer details */}
            <div className="text-center lg:text-left" data-id="element-107">
              <div className="inline-flex items-center gap-2 bg-amber/10 border border-amber/20 rounded-full px-4 py-1.5 mb-6" data-id="element-108">
                <ZapIcon className="w-4 h-4 text-amber" data-id="element-109" />
                <span className="font-body text-amber text-sm font-medium" data-id="element-110">
                  Oferta especial
                </span>
              </div>

              <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-4" data-id="element-111">
                Comienza tu transformación hoy
              </h2>

              <div className="mb-6" data-id="element-112">
                <span className="font-display text-5xl sm:text-6xl font-bold text-amber" data-id="element-113">
                  $10.000
                </span>
                <span className="font-body text-cream-muted/60 text-lg ml-2" data-id="element-114">
                  ARS
                </span>
              </div>

              <p className="font-body text-cream-muted/75 text-base leading-relaxed mb-8" data-id="element-115">
                Por menos de lo que cuesta una comida rápida, tendrás en tus
                manos una guía práctica que transformará tu enfoque diario, te
                devolverá la confianza y te acompañará en tu camino de
                bienestar.
              </p>

              <motion.a href="https://www.equilibriopersonalhoy.com/cart/46514378342558:1" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="inline-block w-full sm:w-auto font-body font-bold text-warm-dark bg-amber hover:bg-amber-light px-10 py-4 rounded-xl text-lg transition-all duration-300 hover:shadow-amber-glow-lg text-center" data-id="element-116">
                ¡Sí, Quiero Transformar Mi Vida!
              </motion.a>

              {/* Guarantee */}
              <div className="mt-8 flex items-start gap-3 text-left" data-id="element-117">
                <ShieldCheckIcon className="w-5 h-5 text-amber/70 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-118" />
                <p className="font-body text-cream-muted/60 text-sm leading-relaxed" data-id="element-119">
                  <span className="text-cream-muted/80 font-medium" data-id="element-120">
                    Garantía de 30 días:
                  </span>{' '}
                  si no sientes que tu autoestima ha empezado a elevarse con las
                  herramientas prácticas, te devolvemos tu dinero sin preguntas.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom encouragement */}
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.6
        }} className="font-body text-cream-muted/50 text-sm text-center mt-10 pt-8 border-t border-warm-border" data-id="element-121">
            No dejes pasar la oportunidad. Comienza hoy mismo tu camino hacia
            una mayor autoestima, energía y bienestar.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}